<template>
    <div class="builder builder-type-1" :class="{ 'loading': loading, 'error': error }">
        <template v-if="!loading && !error && $slots['section-title']">
            <div class="container-fluid content-type-30">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <slot name="section-title"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="!loading && !error && $slots['section-content']">
            <div class="container-fluid" :class="cssClassContent">
                <div class="container">
                    <div class="row row-content">
                        <div class="col-12 col-lg-4 right-column" v-if="showMonitor">
                            <DatasetMonitor :showCount="showCountInMonitor" :showExamples="showExamplesInMonitor" :showShare="showShareInMonitor" />
                        </div>
                        <div class="col-12 col-lg-8 left-column">
                            <slot name="section-content"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="!loading && !error && !$slots['section-content'] && $slots['section-full']">
            <div class="container-fluid" :class="cssClassContent">
                <div class="container">
                    <div class="row row-content">
                        <slot name="section-full"></slot>
                    </div>
                </div>
            </div>
        </template>

        <div v-if="loading" class="loading-section">
            <div class="loading-spinner"></div>
            <div class="loading-text">{{ $t('common.loading_1') }}</div>
        </div>

        <div v-if="error" class="error-section">
            <div class="error-message">{{ error.message }}</div>
        </div>
    </div>
</template>

<script>
    import { scrollToTop } from '@/utils/scroll';
    import DatasetMonitor from '@/components/builder/monitor/DatasetMonitor';
    import { useScreenWidthStore } from '@/stores/utils/screenWidth';

    export default {
        name: 'BuilderBase',
        components: {
            DatasetMonitor
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            error: {
                type: Object,
                required: false
            },
            cssClassContent: {
                type: String,
                default: 'content-type-31'
            }
        },
        computed: {
            routeName() {
                return this.$route.name;
            },
            isBuilder() {
                return this.routeName === 'builder';
            },
            isSpecification() {
                return this.routeName === 'specification';
            },
            showCountInMonitor() {
                return !this.isBuilder;
            },
            screenWidthStore() {
                return useScreenWidthStore();
            },
            hasLargeScreen() {
                return this.screenWidthStore.hasLargeScreen;
            },
            showMonitor() {
                return this.hasLargeScreen || this.isSpecification;
            },
            showExamplesInMonitor() {
                return this.isBuilder && this.hasLargeScreen;
            },
            showShareInMonitor() {
                return this.isBuilder || this.isSpecification;
            }
        },
        mounted() {
            scrollToTop();
        }
    }
</script>
